import { ChevronDownIcon } from "@heroicons/react/16/solid";
import { useState, useRef, useEffect } from "react";
import clsx from "clsx";
import { QrCodeIcon } from "@heroicons/react/24/outline";
import Dialog from "../dialogs";
import { useSidebar } from "../../context/sidebarContext";

const Dropdown = ({
  id,
  label = "Exchange",
  placeholder = "Select Exchange",
  value,
  onChange,
  options,
  className,
  classNameInput,
  classNameLabel,
  classNameDropdown,
  classNameContainer,
  isDialog,
  style = "default",
}) => {
  const { isMobile } = useSidebar();
  const [dataOptions, setDataOptions] = useState([]);
  const [isOpen, setIsOpen] = useState(false);
  const [position, setPosition] = useState("bottom"); // bottom or top
  const boxRef = useRef(null);
  const dropdownRef = useRef(null);

  const handleSelect = (opt) => {
    onChange(opt);
    setIsOpen(false);
  };

  const handleOpen = () => {
    setIsOpen((prev) => !prev);
  };

  useEffect(() => {
    if (options?.length) {
      setDataOptions(options);
    } else {
      setDataOptions([]);
    }
  }, [options]);

  // Detect outside click
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (boxRef.current && !boxRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  // Check dropdown position on open
  useEffect(() => {
    if (isOpen && boxRef.current) {
      const boxRect = boxRef.current.getBoundingClientRect();
      const dropdownHeight = 250; // estimated dropdown height
      const spaceBelow = window.innerHeight - boxRect.bottom;
      const spaceAbove = boxRect.top;

      if (spaceBelow < dropdownHeight && spaceAbove > dropdownHeight) {
        setPosition("top");
      } else {
        setPosition("bottom");
      }
    }
  }, [isOpen]);

  return (
    <div className={`relative w-full ${classNameContainer}`} ref={boxRef}>
      {style === "default" && (
        <div
          className={`rounded-[10px] relative cursor-pointer ${className}`}
          onClick={handleOpen}
        >
          <label
            className={`block text-xs text-gray-500 mb-1 ${classNameLabel}`}
          >
            {label}
          </label>

          <div
            className={`w-full p-[12px] mt-[10px] rounded-[10px] text-sm border-none bg-[#F2F4F8] shadow-[0px_1.5px_1px_#C1C7CD] relative ${classNameInput}`}
          >
            <span className="font-bold text-gray-900">
              {value?.name || placeholder}
            </span>
            <ChevronDownIcon className="absolute w-[24px] h-[24px] right-4 top-[50%] translate-y-[-50%]" />
          </div>
        </div>
      )}
      {style === "group" && (
        <div
          className={`border border-gray-300 rounded-[10px] p-4 py-[14px] relative cursor-pointer bg-white ${className}`}
          onClick={handleOpen}
        >
          <label
            className={`block text-xs text-gray-500 mb-1 ${classNameLabel}`}
          >
            {label}
          </label>

          <div
            className={`flex justify-between items-center text-base cursor-pointer ${classNameInput}`}
          >
            <span className=" font-bold text-gray-900">
              {value?.name || placeholder}
            </span>
            <ChevronDownIcon className="absolute w-[24px] h-[24px] right-4 top-[50%] translate-y-[-50%]" />
          </div>
        </div>
      )}

      {/* non dialog */}
      {/* {} */}
      {/* end non dialog */}

      {isDialog && !!isMobile ? (
        <Dialog
          ref={dropdownRef}
          width={"500px"}
          open={isOpen}
          onClose={() => setIsOpen(false)}
          className={"max-h-[60vh] overflow-y-auto no-scrollbar md:!m-[1rem]"}
          // className={clsx(
          //   "absolute w-full z-10 bg-white border border-gray-200 rounded-lg shadow-[0px_0px_10px_#0002] max-h-[250px] overflow-auto no-scrollbar",
          //   position === "top" ? "bottom-full mb-2" : "mt-2",
          //   classNameDropdown
          // )}
        >
          {dataOptions.map((ex) => (
            <div
              key={ex.id}
              className="flex items-center justify-between p-3 hover:bg-gray-100 cursor-pointer"
              onClick={() => handleSelect(ex)}
            >
              <div className="flex items-center gap-1">
                {/* <QrCodeIcon className="w-[20px] h-[20px]" /> */}
                <span className="text-sm font-medium">{ex.name}</span>
              </div>
            </div>
          ))}
        </Dialog>
      ) : (
        isOpen && (
          <div
            ref={dropdownRef}
            className={clsx(
              "absolute w-full z-[100] bg-white border border-gray-200 rounded-lg shadow-[0px_0px_10px_#0002] max-h-[250px] overflow-auto no-scrollbar",
              position === "top" ? "bottom-full mb-2" : "mt-2",
              classNameDropdown
            )}
          >
            {dataOptions.map((ex) => (
              <div
                key={ex.id}
                className="flex items-center justify-between p-3 hover:bg-gray-100 cursor-pointer"
                onClick={() => handleSelect(ex)}
              >
                <div className="flex items-center gap-1">
                  {/* <QrCodeIcon className="w-[20px] h-[20px]" /> */}
                  <span className="text-sm font-medium">{ex.name}</span>
                </div>
              </div>
            ))}
          </div>
        )
      )}
    </div>
  );
};

export default Dropdown;
